<script>
import {toString} from "@/utils/date";
import ItemComponent from './Item/component.vue';
import Item2Component from './Item/item.component.vue';
export default {
  components: {
    ItemComponent,
    Item2Component
  },
  props: {
    module: {
      type: Object,
    }
  },
  data: () => ({
    loading: false,
    items: [],
    calendar: [],
    date: {
      type: Date,
      default: () => new Date(),
    },
    width: 0,
    widthDialog: '1000px',
    openWindow: false,
  }),
  methods: {
    clickNext() {
      const newDate = new Date(this.date.setMonth(this.date.getMonth() + 1));
      this.date = newDate;
      this.init();
    },
    clickPrev() {
      const newDate = new Date(this.date.setMonth(this.date.getMonth() - 1));
      this.date = newDate;
      this.init();
    },
    init() {
      this.items = [];
      let year = this.date.getFullYear();
      let month = this.date.getMonth();
      const startDate = new Date(year, month, 1);
      let endDate = new Date(year, month, 1);
      endDate = new Date(endDate.setMonth(endDate.getMonth() + 1));
      const count = Math.round((endDate - startDate) / 1000 / 3600 / 24);
      const items = new Array(count)
        .fill('')
        .map((_, i) => {
          const date = new Date(startDate);
          date.setDate(i + 1);
          const label = toString(date);
          return {
            value: label,
            label: toString(date, 'd'),
            date: date,
            dayOfWeek: this.getDayByNumber(date.getDay()),
          };
        });
      this.calendar = items;
      this.width = `calc(100% / ${this.calendar.length})`

      this.module.submit(items[0].value, items[items.length - 1].value);
    },
    getDayByNumber(x) {
      switch (x) {
        case 0:
          return 'Вс'
        case 1:
          return 'Пн'
        case 2:
          return 'Вт'
        case 3:
          return 'Ср'
        case 4:
          return 'Чт'
        case 5:
          return 'Пт'
        case 6:
          return 'Сб'
        default:
          return 'Нп'
      }
    },
    open(value) {
      const date = `${this.calendar[0].value}_${this.calendar[this.calendar.length - 1].value}`
      const url = `/app/#/admin/statistic/${value.value}/date/${date}`
      window.open(url, '_blank');
    },
    open2(value) {
      const date = `${value.dateStart}_${value.dateEnd}`
      const url = `/app/#/admin/statistic/${value.tourId}/date/${date}`
      window.open(url, '_blank');
    },
    close() {
      this.openWindow = false;
    },
    change(data) {
      this.module.get(data).then(() => {
        this.openWindow = true;
      });
    }
  },
  mounted() {
    this.date = new Date();
    this.init();
    this.loading = true;
  },
  computed: {
    items2() {
      return this.module.items;
    },
  },
};
</script>
<template>
  <div class="app-template-page__body" style="margin-top: 15px">
  <div>
    <el-row class="table-board__header">
      <el-col :span="3">
        <div class="table-board__title">
          <label style="color: rgba(0,0,0,0.8);font-weight: 400">Название тура</label>
        </div>
      </el-col>
      <el-col :span="21" v-if="loading">
        <div class="table-board__date">
          <BtnIcon
            class="btn-transparent"
            slot="btn"
            @click="clickPrev"
            icon="el-icon-arrow-left"
          />
          <div style="font-size: 18px; margin-top: 8px;">
            {{ date | date('MMMM') }} ({{ date.getFullYear() }})
          </div>
          <BtnIcon
            class="btn-transparent"
            slot="btn"
            @click="clickNext"
            icon="el-icon-arrow-right"
          />
          </div>
        <div  class="table-board__days">
          <div class="cell"  v-for="(col, j) in calendar" :key="j" :style="{ width: width, }">
            <div class='cell-number'>
              <div>{{col.label}}</div>
              <div>{{col.dayOfWeek}}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="table-board__body">
      <ItemComponent    v-for="(item, j) in items2"
                        :key="j"
                        :item="item"
                        :calendar="calendar"
                        :width="width"
                        @open="open"
                        @open2="open2"
                        @change="change"
      >
      </ItemComponent>
    </div>
    </div>
    <Dialog
      id="item_card_dialog_board"
      :width="widthDialog"
      :active.sync="openWindow"
    >
      <Item2Component
        :module="module"
        @close="close"/>
    </Dialog>
  </div>
</template>
<style lang="scss">
.app-template-page__body{
  height: calc(100vh - 64px);
}
.table-board{
  &__header{
    height: 68px;
    .el-col{
      height: 100%;
    }
    .cell {
      display: flex;
      justify-content: center;
    }
  }
  &__date{
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-top: solid #d5dfe7 1px;
    border-left: solid #d5dfe7 1px;
    border-right: solid #d5dfe7 1px;
    .btn-icon{
      margin: 0px;
      border:none;
      border-radius: none;
      box-shadow: none;
      background: transparent;
    }
  }
  &__days {
    display: flex;
    justify-content: space-between;
    border-top: solid #d5dfe7 1px;
    border-bottom: solid #d5dfe7 1px;
    .cell {
      border-left: solid #d5dfe7 1px;
      &:last-child{
        border-right: solid #d5dfe7 1px;
      }
    }

    div {
      width: 100%;
      font-size: 14px;
      text-align: center;
    }
  }
  &__title{
    height: 100%;
    padding: 17px 20px;
    label{
      font-size: 20px;
      font-weight: 600;
      align-content: center;
    }
  }
  &__body{
    height: calc(100% - 64px);
    margin-top: 4px;
  }
}
</style>
